import React, { Component } from 'react'

class VCGitemPostDate extends Component {
  render() {
    return (
      <div className={this.props.className}>
        <span className='day'>{('0' + this.props.date.getDate()).slice(-2)}</span>
          <span className='month'>{('0' + (this.props.date.getMonth()+1)).slice(-2)}</span>
        <span className='year'>{this.props.date.getFullYear()}</span>
      </div>
    )
  }
}

export default VCGitemPostDate




// WEBPACK FOOTER //
// ./src/components/VCGitemPostDate.js